import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Checkbox,
  Modal,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  SelectItem,
  FormItem,
  InputNumberItem,
  round2Decimals,
  DatePickerItem,
  InputItem,
  ButtonItem,
  NotificacionPolizas,
  SwitchItem,
  ErrorItem,
  cuentaMask,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import ModalComisionesBanco from "../../../../Components/ModalComisionesBanco";
import {
  UserOutlined,
  IdcardOutlined,
  PhoneOutlined,
  ContactsOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { Alert } from "antd5";

const { Option } = Select;

moment.locale("es");

class PagarFactura extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    datosFactura: undefined,
    todasBancos: [],
    objetoBancos: null,
    todasMonedas: null,
    objetoMonedas: null,
    todasFormasDePago: null,
    objetoFormasDePago: null,
    id: this.props.location.state.id,
    notasDeCreditoPendiente: [],
    objetoNotasPendientes: null,
    abonosPendientesProveedores: [],
    objetoAbonosPendientes: null,
    cuentasImpagables: false,
    cuentasAjusteCentavosCxP: false,
    modalAbonosVisible: false,
    abonosSeleccionados: [],
    abonosEnModal: [],
    bancoSeleccionado: null,
    modalComisionVisible: false,
    valoresPendientesPago: null,
    //Complemento Pago con Cuenta Contable (monto extra junto con la factura)
    pagoConCuentaContableCxP: false,
    cuentaContablePagoCxPId: null,
    objetoCuentasContables: [],
    idsCuentasContables: [],
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "bancos/selectBancos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: res.data });
          this.setState({
            objetoBancos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.banco}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cajaefectivo/selectCajaEfectivo",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasBancos: this.state.todasBancos && this.state.todasBancos?.length > 0 ? [...this.state.todasBancos, ...res.data] : res.data });
          this.setState({
            objetoBancos: this.state.objetoBancos && this.state.objetoBancos?.length > 0 ? [...this.state.objetoBancos, ...res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            })] : res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + (value.banco ? ' - ' + value.banco : '')}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "formasdepago/selectFormasDePago",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasFormasDePago: res.data });
          this.setState({
            objetoFormasDePago: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_FormaPago + ' - ' + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post("monedas/selectMonedas", null, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasMonedas: res.data });
          this.setState({
            objetoMonedas: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cuentasporpagar/datosPagarFactura",
        {
          empresaId: this.props.empresaId,
          facturaId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion de la factura");
        } else {
          this.formRef.current.setFieldsValue({ monedaId: res.data[0].monedaId, tipoDeCambioCompra: res.data[0].tipoDeCambio, tipoDeCambioPago: res.data[0].tipoDeCambio })
          this.setState({
            datosFactura: res.data[0],
            notasDeCreditoPendiente: res.data.notasDeCreditoPendiente,
            objetoNotasPendiente: res.data.notasDeCreditoPendiente.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {moment(value.fechaFactura).format('L') + " - " + dineroDisabledMask(value.totalPagar - value.totalPagado) + ' - ' + value.moneda.abreviacion +
                  (value.descripcion ? " | " + value.descripcion : "")}
                </Option>
              );
            }),
            abonosPendientesProveedores: res.data.abonosPendientesProveedores,
            objetoAbonosPendientes: res.data.abonosPendientesProveedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {moment(value.fechaPago).format('L') + " - " + dineroDisabledMask(value.monto - (value.totalPagadoAbono || 0)) + ' - ' + value.moneda?.abreviacion}
                </Option>
              );
            }),
            cuentasImpagables: res.data.cuentasImpagables,
            cuentasAjusteCentavosCxP: res.data.cuentasAjusteCentavosCxP,
            pagoConCuentaContableCxP: res.data.pagoConCuentaContableCxP === true,
            cuentaContablePagoCxPId: res.data.cuentaContablePagoCxPId || null,
          });
          this.onChangeMoneda(res.data[0].monedaId, 1)
        }
      });

    //Las cuentas contables solo hacen falta si la empresa paga montos extra a cuenta contable
    if (this.state.pagoConCuentaContableCxP) {
      await this.consultarCuentasContables()
    }

    this.onChangeMoneda(this.formRef.current.getFieldValue('monedaId'), 2)
    this.setState({ loading: false });
  }

  async consultarCuentasContables() {
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ objetoCuentasContables: [], idsCuentasContables: [] })
        } else {
          this.setState({
            idsCuentasContables: res.data.map((value) => value._id.toString()),
            objetoCuentasContables: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + ' - ' + value.descripcion}
                </Option>
              );
            }),
          });
        }
      })
      .catch(() => {
        message.error("No se pudieron consultar las cuentas contables");
      });
  }

  //Cuenta predefinida en Complementos, solo si esta en la lista de cuentas finales
  cuentaContablePagoDefault() {
    const cuentaId = this.state.cuentaContablePagoCxPId
    if (cuentaId && this.state.idsCuentasContables.includes(cuentaId.toString())) {
      return cuentaId
    }
    return undefined
  }

  //El switch no viaja al backend; sin el switch encendido tampoco viajan el monto extra ni la cuenta
  limpiarValoresCuentaContable(values) {
    const valores = { ...values }
    const conMontoExtra = !!(this.state.pagoConCuentaContableCxP && valores.pagoConCuentaContable)
    delete valores.pagoConCuentaContable
    if (!conMontoExtra) {
      delete valores.montoCuentaContable
      delete valores.cuentaContablePagoId
    }
    return valores
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (values.pagarConNotas) {
      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === values.notaId.toString())
      if (values.monto > notaCredito.totalPagar) {
        return message.info('No se puede pagar mas del saldo pendiente de la nota de credito')
      }
    }
    if (values.pagarConAbono) {
      if (this.state.abonosSeleccionados.length > 0) {
        const totalDisponible = this.state.abonosSeleccionados.reduce((acc, id) => {
          const abono = this.state.abonosPendientesProveedores.find(a => a._id.toString() === id.toString())
          return acc + (abono ? round2Decimals(abono.monto - (abono.totalPagadoAbono || 0)) : 0)
        }, 0)
        if (values.monto > totalDisponible) {
          return message.info('No se puede pagar mas del saldo pendiente de los abonos seleccionados')
        }
      } else {
        const abonoProveedor = this.state.abonosPendientesProveedores.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === values.abonoId.toString())
        if (values.monto > (abonoProveedor.monto - abonoProveedor.totalPagadoAbono)) {
          return message.info('No se puede pagar mas del saldo pendiente del abono')
        }
      }
    }
    if (values.monedaId && values.monedaId === this.state.datosFactura?.monedaId) {
      if (round2Decimals(values.tipoDeCambioCompra) !== round2Decimals(values.tipoDeCambioPago)) {
        return message.error('El tipo de cambio del pago debe ser igual al de la factura cuando la moneda es la misma')
      }
    }
    if (this.state.pagoConCuentaContableCxP && values.pagoConCuentaContable) {
      if (!(Number(values.montoCuentaContable) > 0)) {
        return message.error('Capture el monto extra a cuenta contable')
      }
      if (!values.cuentaContablePagoId) {
        return message.error('Seleccione la cuenta contable del monto extra')
      }
      if (!values.bancoId) {
        return message.error('Seleccione el banco del pago')
      }
    }
    if (this.state.bancoSeleccionado?.paquetesComision?.length > 0) {
      this.setState({ modalComisionVisible: true, valoresPendientesPago: values })
      return
    }
    this.enviarPago(values, [])
  }
  atras() {
    this.props.history.goBack();
  }

  onChangeBanco(bancoId) {
    if (bancoId) {
      const banco = this.state.todasBancos.find((valueTodosBancos) => valueTodosBancos._id.toString() === bancoId.toString())
      if (banco.caja) {
        message.info('Se tendra que reponer el saldo en la caja chica')
      }
      this.setState({ bancoSeleccionado: banco || null })
    } else {
      this.setState({ bancoSeleccionado: null })
    }
  }

  enviarPago(values, paquetesComisionIds) {
    this.setState({ loading: true });
    axios
      .post(
        "cuentasporpagar/pagarFactura",
        {
          ...this.limpiarValoresCuentaContable(values),
          empresaId: this.props.empresaId,
          facturaId: this.state.id,
          abonosIds: this.state.abonosSeleccionados.length > 0 ? this.state.abonosSeleccionados : undefined,
          paquetesComisionIds,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado un pago");
          NotificacionPolizas(res.data.polizasId)
          this.formRef.current.resetFields();
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message);
        } else {
          message.error("Hubo un error y no se efectuo el pago");
        }
      });
  }

  renderModalComision() {
    const { modalComisionVisible, valoresPendientesPago, bancoSeleccionado } = this.state
    return (
      <ModalComisionesBanco
        visible={modalComisionVisible}
        banco={bancoSeleccionado}
        moneda={(this.state.todasMonedas || []).find(valueMoneda => valueMoneda._id.toString() === bancoSeleccionado?.monedaId?.toString())?.abreviacion}
        onCancel={() => this.setState({ modalComisionVisible: false })}
        onOk={(paquetesComisionIds) => {
          const values = valoresPendientesPago
          this.setState({ modalComisionVisible: false, valoresPendientesPago: null })
          this.enviarPago(values, paquetesComisionIds)
        }}
      />
    )
  }

  onChangeNotaDeCredito(notaId) {
    if (notaId) {
      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === notaId.toString())
      this.formRef.current.setFieldsValue({ monedaId: notaCredito.monedaId, tipoDeCambioPago: notaCredito.tipoDeCambio })
    }
  }

  onChangeMoneda(value, tipo, fecha) {
    if (value && value !== "60c7e4396465ad440c41c15a") {
      axios
        .post(
          "tipoDeCambio/obtenerTipoDeCambio",
          {
            monedaId: value,
            empresaId: this.props.empresaId,
            fecha: fecha || undefined,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            if (res.data.monedaString && res.data.dia) {
              message.success(
                "Se ha obtenido el tipo de cambio" +
                (res.data.monedaString ? " " + res.data.monedaString : "") +
                (res.data.dia ? " del día " + res.data.dia : "")
              );
            }
            if (tipo === 1) {
              this.formRef.current.setFieldsValue({
                tipoDeCambioCompra: res.data.tipoDeCambio,
              });
              const monedaIdPago = this.formRef.current.getFieldValue('monedaId')
              if (monedaIdPago && monedaIdPago === this.state.datosFactura?.monedaId) {
                this.formRef.current.setFieldsValue({ tipoDeCambioPago: res.data.tipoDeCambio });
              }
            } else {
              if (value === this.state.datosFactura?.monedaId) {
                const tipoDeCambioCompra = this.formRef.current.getFieldValue('tipoDeCambioCompra')
                this.formRef.current.setFieldsValue({ tipoDeCambioPago: tipoDeCambioCompra });
              } else {
                this.formRef.current.setFieldsValue({
                  tipoDeCambioPago: res.data.tipoDeCambio,
                });
              }
            }
          }
        });
    } else {
      this.formRef.current.setFieldsValue({ tipoDeCambioPago: 1 });
    }
  }

  onChangeCheque(value) {
    if (value.target.checked) {
      this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d59' })
    } else {
      this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d5a' })
    }
  }

  onChangeAbono(abonoId) {
    if (abonoId) {
      const abono = this.state.abonosPendientesProveedores.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === abonoId.toString())
      this.formRef.current.setFieldsValue({ monedaId: abono.monedaId, tipoDeCambioPago: abono.tipoDeCambioPago, fechaPago: abono.fechaPago ? moment(abono.fechaPago) : null })
    }
  }

  renderModalAbonos() {
    const { abonosPendientesProveedores, abonosEnModal, modalAbonosVisible } = this.state
    const totalSeleccionado = abonosEnModal.reduce((acc, id) => {
      const abono = abonosPendientesProveedores.find(a => a._id.toString() === id.toString())
      return acc + (abono ? round2Decimals(abono.monto - (abono.totalPagadoAbono || 0)) : 0)
    }, 0)
    const confirmarAbonos = () => {
      if (abonosEnModal.length === 0) return message.info('Selecciona al menos un abono')
      const firstAbono = abonosPendientesProveedores.find(a => a._id.toString() === abonosEnModal[0].toString())
      this.setState({ abonosSeleccionados: [...abonosEnModal], modalAbonosVisible: false }, () => {
        if (firstAbono) {
          this.formRef.current.setFieldsValue({
            monedaId: firstAbono.monedaId,
            tipoDeCambioPago: firstAbono.tipoDeCambioPago,
            fechaPago: firstAbono.fechaPago ? moment(firstAbono.fechaPago) : null,
          })
        }
      })
    }
    return (
      <Modal
        title="Seleccionar Abonos"
        visible={modalAbonosVisible}
        onCancel={() => this.setState({ modalAbonosVisible: false, abonosEnModal: [...this.state.abonosSeleccionados] })}
        footer={
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ color: '#555', fontWeight: 600, fontSize: 13 }}>
              {abonosEnModal.length > 0
                ? `${abonosEnModal.length} seleccionado(s) — Disponible: ${dineroDisabledMask(totalSeleccionado)}`
                : 'Ninguno seleccionado'}
            </span>
            <div style={{ display: 'flex', gap: 8 }}>
              <ButtonItem onClick={() => this.setState({ modalAbonosVisible: false, abonosEnModal: [...this.state.abonosSeleccionados] })}>
                Cancelar
              </ButtonItem>
              <ButtonItem type="primary" cyanB onClick={confirmarAbonos}>
                Confirmar
              </ButtonItem>
            </div>
          </div>
        }
      >
        <div style={{ maxHeight: 340, overflowY: 'auto', margin: '0 -24px' }}>
          {abonosPendientesProveedores.map(abono => {
            const disponible = round2Decimals(abono.monto - (abono.totalPagadoAbono || 0))
            const checked = abonosEnModal.includes(abono._id)
            return (
              <div
                key={abono._id}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '10px 24px', cursor: 'pointer',
                  borderBottom: '1px solid #f0f0f0',
                  background: checked ? '#f0fcfe' : '#fff',
                  transition: 'background 0.15s',
                }}
                onClick={() => {
                  const newSelected = checked
                    ? abonosEnModal.filter(id => id !== abono._id)
                    : [...abonosEnModal, abono._id]
                  this.setState({ abonosEnModal: newSelected })
                }}
              >
                <Checkbox checked={checked} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{moment(abono.fechaPago).format('L')}</div>
                  <div style={{ color: '#888', fontSize: 12 }}>
                    {dineroDisabledMask(disponible)} {abono.moneda?.abreviacion}
                  </div>
                </div>
                {checked && (
                  <span style={{ color: '#00BFD6', fontSize: 11, fontWeight: 600 }}>✓</span>
                )}
              </div>
            )
          })}
        </div>
      </Modal>
    )
  }

  renderMonedaCard() {
    const abreviacionFactura = this.state.datosFactura?.moneda?.abreviacion || '';
    const esFacturaMXN = this.state.datosFactura?.monedaId === '60c7e4396465ad440c41c15a';
    return (
      <Row gutter={[8, 0]}>
        <Col span={24}>
          {esFacturaMXN ? (
            <FormItem hidden name="tipoDeCambioCompra" initialValue={1}>
              <InputNumberItem />
            </FormItem>
          ) : (
            <Row align="middle" gutter={[8, 0]}>
              <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                <FormItem
                  required
                  number
                  margin
                  label={`T.C. ${abreviacionFactura}`}
                  name="tipoDeCambioCompra"
                  type="number"
                  initialValue={1}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <InputNumberItem
                    initialValue={1}
                    dinero
                    placeholder={`T.C. ${abreviacionFactura}`}
                    onChange={(value) => {
                      const monedaIdPago = this.formRef.current.getFieldValue('monedaId')
                      if (monedaIdPago && monedaIdPago === this.state.datosFactura?.monedaId) {
                        this.formRef.current.setFieldsValue({ tipoDeCambioPago: value })
                      }
                    }}
                  />
                </FormItem>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: 11,
                    color: '#888',
                    padding: '6px 8px',
                    background: '#fafafa',
                    border: '1px dashed #e8e8e8',
                    borderRadius: 4,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  T.C. Factura: <strong style={{ color: '#555' }}>{dineroDisabledMask(this.state.datosFactura?.tipoDeCambio)}</strong>
                </div>
              </Col>
            </Row>
          )}

          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const pagarConNotas = getFieldValue('pagarConNotas')
              const pagarConImpagable = getFieldValue('pagarConImpagable')
              const pagarConAjusteCentavos = getFieldValue('pagarConAjusteCentavos')
              return (
                <FormItem
                  required
                  margin
                  name="monedaId"
                  label="Moneda Pago"
                  labelCol={{ span: 9 }}
                  wrapperCol={{ span: 15 }}
                  initialValue={'60c7e4396465ad440c41c15a'}
                >
                  <SelectItem
                    placeholder="Moneda"
                    disabled={pagarConNotas || pagarConImpagable || pagarConAjusteCentavos}
                    onChange={(value) => {
                      this.onChangeMoneda(value, 2)
                    }}
                  >
                    {this.state.objetoMonedas}
                  </SelectItem>
                </FormItem>
              )
            }}
          </FormItem>

          <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.pagarConNotas !== curr.pagarConNotas}>
            {({ getFieldValue }) => {
              const monedaId = getFieldValue('monedaId')
              const pagarConNotas = getFieldValue('pagarConNotas')
              const pagarConAbono = getFieldValue('pagarConAbono')
              const moneda = this.state.todasMonedas ? this.state.todasMonedas.find((valueTodasMonedas) => valueTodasMonedas._id.toString() === monedaId.toString()) : null
              return (
                <FormItem
                  required
                  number
                  margin
                  hidden={monedaId === '60c7e4396465ad440c41c15a'}
                  label={`T.C. ${moneda?.abreviacion ? moneda.abreviacion : ''}`}
                  name="tipoDeCambioPago"
                  type="number"
                  initialValue={1}
                   labelCol={{ span: 9 }}
                  wrapperCol={{ span: 15 }}
                >
                  <InputNumberItem
                    disabled={monedaId === '60c7e4396465ad440c41c15a' || pagarConNotas || pagarConAbono || monedaId === this.state.datosFactura?.monedaId}
                    dinero
                    placeholder={`T.C. ${moneda?.abreviacion ? moneda.abreviacion : ''}`}
                  />
                </FormItem>
              )
            }}
          </FormItem>
        </Col>
      </Row>
    );
  }

  renderDatosPagoCard() {
    return (
      <Row gutter={[8, 0]}>
            <Col span={24} xs={24} sm={24} lg={24} xl={24}>
              <FormItem
                label="Fecha de Pago"
                name="fechaPago"
                required
                margin
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 17 }}
              >
                <DatePickerItem
                  placeholder="Fecha de Pago"
                  allowClear={false}
                  onChange={(date) => {
                    const monedaIdPago = this.formRef.current.getFieldValue('monedaId')
                    const monedaIdCompra = this.state.datosFactura?.monedaId
                    if (monedaIdCompra && monedaIdCompra !== '60c7e4396465ad440c41c15a') {
                      this.onChangeMoneda(monedaIdCompra, 1, date)
                    }
                    if (monedaIdPago && monedaIdPago !== '60c7e4396465ad440c41c15a') {
                      this.onChangeMoneda(monedaIdPago, 2, date)
                    }
                  }}
                />
              </FormItem>
              </Col>

              <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                {this.state.notasDeCreditoPendiente.length > 0 &&
                  <FormItem
                    name="pagarConNotas"
                    label="Pagar C/Notas"
                    tooltip={{ title: "Pagar la factura con notas de credito" }}
                    margin
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 17 }}
                    pattern
                    valuePropName="checked"
                  >
                    <SwitchItem
                      placeholder="Pagar Con Notas"
                      onChange={(checked) => {
                        if (checked) {
                          this.formRef.current.setFieldsValue({
                            pagarConAbono: false,
                            abonoId: null,
                            pagarConImpagable: false,
                            pagarConAjusteCentavos: false,
                            pagoConCuentaContable: false,
                          })
                        }
                      }}
                    />
                  </FormItem>
                }
              </Col>

          <Col span={24}>
          {this.state.abonosPendientesProveedores.length > 0 &&
            <FormItem
              name="pagarConAbono"
              label="Cobrar C/Abono"
              tooltip={{ title: "Cobrar la venta con un abono" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConNotas: false,
                      notaId: null,
                      pagarConImpagable: false,
                      pagarConAjusteCentavos: false,
                      pagoConCuentaContable: false,
                    })
                  } else {
                    this.setState({ abonosSeleccionados: [], abonosEnModal: [] })
                    this.formRef.current.setFieldsValue({ abonoId: null })
                  }
                }}
                placeholder="Cobrar Con Abono"
              />
            </FormItem>
          }
          {this.state.cuentasImpagables &&
            <FormItem
              name="pagarConImpagable"
              label="Impagable"
              tooltip={{ title: "Pagar como impagable" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 17 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConNotas: false,
                      notaId: null,
                      pagarConAbono: false,
                      abonoId: null,
                      pagarConAjusteCentavos: false,
                      pagoConCuentaContable: false,
                      monedaId: this.state.datosFactura?.monedaId,
                    })
                  }
                }}
                placeholder="Pagar Como Impagable"
              />
            </FormItem>
          }
          {this.state.cuentasAjusteCentavosCxP &&
            <FormItem
              name="pagarConAjusteCentavos"
              label="Ajuste de centavos"
              tooltip={{ title: "Pagar como ajuste de centavos" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 17 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.formRef.current.setFieldsValue({
                      pagarConNotas: false,
                      notaId: null,
                      pagarConAbono: false,
                      abonoId: null,
                      pagarConImpagable: false,
                      pagoConCuentaContable: false,
                      monedaId: this.state.datosFactura?.monedaId,
                    })
                  }
                }}
                placeholder="Pagar Como Ajuste de centavos"
              />
            </FormItem>
          }
          {this.state.pagoConCuentaContableCxP &&
            <FormItem
              name="pagoConCuentaContable"
              label="Extra a cuenta contable"
              tooltip={{ title: "Pagar, junto con la factura y del mismo banco, un monto extra que se carga a una cuenta contable" }}
              margin
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 17 }}
              pattern
              valuePropName="checked"
            >
              <SwitchItem
                onChange={(checked) => {
                  if (checked) {
                    this.setState({ abonosSeleccionados: [], abonosEnModal: [] })
                    this.formRef.current.setFieldsValue({
                      pagarConNotas: false,
                      notaId: null,
                      pagarConAbono: false,
                      abonoId: null,
                      pagarConImpagable: false,
                      pagarConAjusteCentavos: false,
                      cuentaContablePagoId: this.cuentaContablePagoDefault(),
                    })
                  } else {
                    this.formRef.current.setFieldsValue({ montoCuentaContable: undefined })
                  }
                }}
                placeholder="Pagar extra a cuenta contable"
              />
            </FormItem>
          }

          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const pagarConNotas = getFieldValue('pagarConNotas')
              const pagarConAbono = getFieldValue('pagarConAbono')
              const pagarConImpagable = getFieldValue('pagarConImpagable')
              const pagarConAjusteCentavos = getFieldValue('pagarConAjusteCentavos')

              if (pagarConNotas) {
                return (
                  <FormItem
                    label="Nota"
                    name="notaId"
                    margin
                    required
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                  >
                    <SelectItem placeholder="Nota" dropdownMatchSelectWidth={false} onChange={this.onChangeNotaDeCredito.bind(this)} >
                      {this.state.objetoNotasPendiente}
                    </SelectItem>
                  </FormItem>
                )
              } else if (pagarConAbono) {
                const abonosSeleccionados = this.state.abonosSeleccionados
                if (abonosSeleccionados.length > 0) {
                  const totalDisponible = abonosSeleccionados.reduce((acc, id) => {
                    const abono = this.state.abonosPendientesProveedores.find(a => a._id.toString() === id.toString())
                    return acc + (abono ? round2Decimals(abono.monto - (abono.totalPagadoAbono || 0)) : 0)
                  }, 0)
                  return (
                    <FormItem
                      label=" "
                      colon={false}
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      style={{ marginBottom: 8 }}
                    >
                      <Row align="middle" gutter={[6, 0]}>
                        <Col flex="auto">
                          <div style={{ padding: '6px 10px', background: '#f0fcfe', border: '1px solid #b5edf3', borderRadius: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontWeight: 600, fontSize: 13 }}>{abonosSeleccionados.length} abono(s)</span>
                            <span style={{ color: '#555', fontSize: 12 }}>Disp: {dineroDisabledMask(totalDisponible)}</span>
                          </div>
                        </Col>
                        <Col flex="none">
                          <ButtonItem size="small" onClick={() => this.setState({ modalAbonosVisible: true, abonosEnModal: [...abonosSeleccionados] })}>
                            Cambiar
                          </ButtonItem>
                        </Col>
                        <Col flex="none">
                          <ButtonItem size="small" danger onClick={() => this.setState({ abonosSeleccionados: [], abonosEnModal: [] })}>
                            Quitar
                          </ButtonItem>
                        </Col>
                      </Row>
                    </FormItem>
                  )
                }
                return (
                  <Row align="middle" gutter={[6, 0]}>
                    <Col span={19}>
                      <FormItem
                        label="Abono"
                        name="abonoId"
                        margin
                        required
                        labelCol={{ span: 10 }}
                        wrapperCol={{ span: 14 }}
                      >
                        <SelectItem placeholder="Abono" onChange={this.onChangeAbono.bind(this)}>
                          {this.state.objetoAbonosPendientes}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={5} style={{ textAlign: 'center', paddingBottom: 8 }}>
                      <ButtonItem
                        size="small"
                        onClick={() => this.setState({ modalAbonosVisible: true, abonosEnModal: [] })}
                      >
                        Varios
                      </ButtonItem>
                    </Col>
                  </Row>
                )
              } if (pagarConImpagable || pagarConAjusteCentavos) {
                return null
              } else {
                return (
                  <>
                    <Row gutter={[8, 0]}>
                      <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                        <FormItem
                          label="Banco"
                          name="bancoId"
                          margin
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 15 }}
                          required
                        >
                          <SelectItem placeholder="Banco" onChange={this.onChangeBanco.bind(this)}>
                            {this.state.objetoBancos}
                          </SelectItem>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row gutter={[8, 0]} align="middle">
                      <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                        <FormItem
                          label="Cheque"
                          name="cheque"
                          margin
                          labelCol={{ xs: 7, sm: 7, lg: 16, xl: 16 }}
                          wrapperCol={{ xs: 17, sm: 17, lg: 10, xl: 10 }}
                          valuePropName="checked"
                          initialValue={this.props.location.state.cheque}
                        >
                          <Checkbox onChange={this.onChangeCheque.bind(this)} />
                        </FormItem>
                      </Col>
                      <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const cheque = getFieldValue('cheque')
                            const bancoId = getFieldValue('bancoId')
                            if (cheque && bancoId) {
                              let consecutivoCheque = this.state.todasBancos.find(tBancos => tBancos._id.toString() === bancoId.toString()).consecutivoCheque
                              if (!consecutivoCheque) {
                                consecutivoCheque = 1
                              }
                              return (
                                <div
                                  style={{
                                    textAlign: 'center',
                                    padding: '4px 8px',
                                    background: '#e6f7ff',
                                    border: '1px solid #91d5ff',
                                    borderRadius: 4,
                                    fontSize: 13,
                                    color: '#0070b9',
                                    fontWeight: 600,
                                  }}
                                >
                                  N°: {consecutivoCheque}
                                </div>
                              )
                            }
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                    <Row gutter={[8, 0]}>
                      <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                        <FormItem shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const cheque = getFieldValue('cheque')
                            return (
                              <FormItem
                                name="formaDePagoId"
                                label="F Pago"
                                initialValue="6125149afe07662acc100d5a"
                                margin
                                required
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 15 }}
                              >
                                <SelectItem disabled={cheque} placeholder="Forma de Pago">
                                  {this.state.objetoFormasDePago}
                                </SelectItem>
                              </FormItem>
                            )
                          }}
                        </FormItem>
                      </Col>
                    </Row>
                    {this.state.pagoConCuentaContableCxP && getFieldValue('pagoConCuentaContable') &&
                      <>
                        <Row gutter={[8, 0]}>
                          <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                            <FormItem
                              label="Cuenta contable"
                              name="cuentaContablePagoId"
                              margin
                              required
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 15 }}
                            >
                              <SelectItem placeholder="Cuenta contable del monto extra">
                                {this.state.objetoCuentasContables}
                              </SelectItem>
                            </FormItem>
                          </Col>
                        </Row>
                        <Row gutter={[8, 0]}>
                          <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                            <FormItem
                              label="Monto extra"
                              name="montoCuentaContable"
                              tooltip={{ title: "Sale del mismo banco junto con el pago de la factura y se carga a la cuenta contable" }}
                              margin
                              required
                              number
                              type="number"
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 15 }}
                            >
                              <InputNumberItem dinero placeholder="Monto extra a cuenta contable" />
                            </FormItem>
                          </Col>
                        </Row>
                        <Row gutter={[8, 0]}>
                          <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                            <div style={{ textAlign: 'right', fontSize: 12, color: '#666', marginBottom: 8 }}>
                              Sale del banco: <b>{dineroDisabledMask(round2Decimals((Number(getFieldValue('monto')) || 0) + (Number(getFieldValue('montoCuentaContable')) || 0)))}</b>
                              {' '}(factura {dineroDisabledMask(Number(getFieldValue('monto')) || 0)} + extra {dineroDisabledMask(Number(getFieldValue('montoCuentaContable')) || 0)})
                            </div>
                          </Col>
                        </Row>
                      </>
                    }
                  </>
                )
              }
            }}
          </FormItem>

          <Row gutter={[8, 0]} align="middle">
            <Col span={14} xs={24} sm={24} lg={14} xl={14}>
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  let tipoDeCambioCompra = getFieldValue('tipoDeCambioCompra')
                  let tipoDeCambioPago = getFieldValue('tipoDeCambioPago')
                  const pagarConNotas = getFieldValue('pagarConNotas')
                  const pagarConAbono = getFieldValue('pagarConAbono')

                  const equivalencia = tipoDeCambioPago / tipoDeCambioCompra
                  const totalPagarFactura = this.state.datosFactura?.totalPagar || 0;
                  const totalPagadoFactura = this.state.datosFactura?.totalPagado || 0;
                  const saldoPendienteFactura = round2Decimals(
                    (totalPagarFactura - totalPagadoFactura) / equivalencia
                  );

                  let saldoPendiente = saldoPendienteFactura

                  if (pagarConNotas) {
                    const notaId = getFieldValue('notaId')
                    if (notaId) {
                      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === notaId.toString())

                      saldoPendiente = Math.min(
                        round2Decimals(notaCredito.totalPagar - notaCredito.totalPagado),
                        saldoPendienteFactura
                      )
                    }
                  } else if (pagarConAbono) {
                    if (this.state.abonosSeleccionados.length > 0) {
                      const totalDisponible = this.state.abonosSeleccionados.reduce((acc, id) => {
                        const abono = this.state.abonosPendientesProveedores.find(a => a._id.toString() === id.toString())
                        return acc + (abono ? round2Decimals(abono.monto - (abono.totalPagadoAbono || 0)) : 0)
                      }, 0)
                      saldoPendiente = Math.min(totalDisponible, saldoPendienteFactura)
                    } else {
                      const abonoId = getFieldValue('abonoId')
                      if (abonoId) {
                        const abono = this.state.abonosPendientesProveedores.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === abonoId.toString())
                        saldoPendiente = Math.min(
                          round2Decimals(abono.totalPagar - abono.totalPagadoAbono),
                          saldoPendienteFactura
                        )
                      }
                    }
                  }
                  return (
                    <FormItem
                      required
                      number
                      margin
                      labelCol={{ xs: 7, sm: 7, lg: 14, xl: 14 }}
                      wrapperCol={{ xs: 17, sm: 17, lg: 12, xl: 12 }}
                      label="Monto a pagar"
                      name="monto"
                      type="number"
                      max={saldoPendiente}
                    >
                      <InputNumberItem dinero placeholder="Monto" />
                    </FormItem>
                  );
                }}
              </FormItem>
            </Col>
            <Col
              xs={{ span: 17, offset: 7 }}
              sm={{ span: 17, offset: 7 }}
              lg={{ span: 10, offset: 0 }}
              xl={{ span: 10, offset: 0 }}
            >
              
              <ButtonItem
                style={{ marginLeft: 10 }}
                size="small"
                type="primary"
                cyan
                onClick={() => {
                  let tipoDeCambioCompra = this.formRef.current.getFieldValue('tipoDeCambioCompra')
                  let tipoDeCambioPago = this.formRef.current.getFieldValue('tipoDeCambioPago')
                  const pagarConNotas = this.formRef.current.getFieldValue('pagarConNotas')
                  const pagarConAbono = this.formRef.current.getFieldValue('pagarConAbono')
                  const equivalencia = tipoDeCambioPago / tipoDeCambioCompra
                  let totalPagar =
                    this.state.datosFactura?.totalPagar || 0;
                  let totalPagado =
                    this.state.datosFactura?.totalPagado || 0;
                  let saldoPendiente = round2Decimals(
                    (totalPagar - totalPagado) / equivalencia
                  );
                  if (pagarConNotas) {
                    const notaId = this.formRef.current.getFieldValue('notaId')

                    if (notaId) {
                      const notaCredito = this.state.notasDeCreditoPendiente.find((valueTodasNotas) => valueTodasNotas._id.toString() === notaId.toString())

                      this.formRef.current.setFieldsValue({
                        monto: Math.min(round2Decimals(notaCredito.totalPagar - notaCredito.totalPagado), saldoPendiente),
                      });
                    }
                  } else if (pagarConAbono) {
                    if (this.state.abonosSeleccionados.length > 0) {
                      const totalDisponible = this.state.abonosSeleccionados.reduce((acc, id) => {
                        const abono = this.state.abonosPendientesProveedores.find(a => a._id.toString() === id.toString())
                        return acc + (abono ? round2Decimals(abono.monto - (abono.totalPagadoAbono || 0)) : 0)
                      }, 0)
                      this.formRef.current.setFieldsValue({ monto: Math.min(totalDisponible, saldoPendiente) })
                    } else {
                      const abonoId = this.formRef.current.getFieldValue('abonoId')
                      if (abonoId) {
                        const abono = this.state.abonosPendientesProveedores.find((valueTodasAbonos) => valueTodasAbonos._id.toString() === abonoId.toString())
                        this.formRef.current.setFieldsValue({
                          monto: Math.min(round2Decimals(abono.monto - abono.totalPagadoAbono), saldoPendiente),
                        })
                      }
                    }
                  } else {
                    this.formRef.current.setFieldsValue({
                      monto: saldoPendiente,
                    });
                  }
                }}
              >
                Pendiente
              </ButtonItem>
            </Col>
          </Row>

          <Row>
            <Col span={24} xs={24} sm={24} lg={24} xl={24}>
              <FormItem
                name="referencia"
                label="Referencia"
                margin
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 15 }}
                pattern
              >
                <InputItem placeholder="Referencia" />
              </FormItem>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  renderResumenCard() {
    const totalPagar = this.state.datosFactura?.totalPagar || 0;
    const totalPagado = this.state.datosFactura?.totalPagado || 0;
    const saldoPendiente = totalPagar - totalPagado;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 8,
          borderLeft: '4px solid #FF6A0D',
          borderTopLeftRadius: 8,
          borderBottomLeftRadius: 8,
          width: '100%',
          minWidth: 0,
          overflowX: 'auto',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '7px 8px',
            borderBottom: '1px dashed #d8d8d8',
          }}
        >
          <span style={{ color: '#666', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>
            Total a Pagar
          </span>
          <span style={{ color: '#333', fontSize: 15, fontWeight: 700 }}>
            {dineroDisabledMask(totalPagar)}
          </span>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '7px 8px',
            borderBottom: '1px dashed #d8d8d8',
          }}
        >
          <span style={{ color: '#666', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>
            Total Pagado
          </span>
          <span style={{  fontSize: 15, fontWeight: 700 }}>
            {dineroDisabledMask(totalPagado)}
          </span>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '14px 12px',
            marginTop: 12,
            boxShadow: '0 2px 6px rgba(131, 131, 131, 0.11)',
          }}
        >
          <span
            style={{
              fontSize: 12,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: 0.5,
            }}
          >
            Saldo Pendiente
          </span>
          <span style={{ color: '#ff4d4f', fontSize: 18, fontWeight: 700 }}>
            {dineroDisabledMask(saldoPendiente)}
          </span>
        </div>
      </div>
    );
  }

  renderProveedorInfoCard() {
    const proveedor = this.state.datosFactura?.proveedor;
    const proyecto = this.state.datosFactura?.proyecto;
    if (!proveedor) return null;


    // Renderizar el nombre en negritas usando un elemento <strong>
    const proveedorNombre = proveedor.nombre
      ? <strong>{`${proveedor.nombre} ${proveedor.apellidoPaterno || ''} ${proveedor.apellidoMaterno || ''}`.trim()}</strong>
      : <strong>{proveedor.razonSocial || 'Proveedor'}</strong>;

    return (
      <Row>
        <InfoCard
          title="PROVEEDOR"
          icon={<UserOutlined />}
          iconColor="#00BFD6"
          accentColor="#00BFD6"
          compact
          sections={[
            {
              title: "Información",
              icon: <IdcardOutlined />,
              iconColor: "#00BFD6",
              lg: 6,
              items: [
                { label: "RFC", value: proveedor.rfc },
                { label: "Nombre", value: proveedorNombre },
                { label: "Correo", value: proveedor.correo },
              ],
            },
            {
              title: "Teléfonos",
              icon: <PhoneOutlined />,
              iconColor: "#FF6A0D",
              lg: 6,
              items: [
                { label: "Teléfono", value: proveedor.telefono },
                { label: "Celular", value: proveedor.celular },
              ],
            },
            {
              title: "Contacto",
              icon: <ContactsOutlined />,
              iconColor: "#C9DF00",
              lg: 6,
              items: [
                { label: "Persona", value: proveedor.nombreContacto },
                { label: "Teléfono", value: proveedor.telefonoContacto },
                { label: "Correo", value: proveedor.correoContacto },
              ],
            },
            {
              title: "Proyecto",
              icon: <EnvironmentOutlined />,
              iconColor: "#795548",
              lg: 6,
              items: [
                { label: "Nombre", value: proyecto?.nombre },
                { label: "Días Crédito", value: proveedor.diasCredito ? `${proveedor.diasCredito} días` : null },
              ],
            },
          ]}
        />
      </Row>
    );
  }

  render() {
    const isMobile = false;
    const proveedor = this.state.datosFactura?.proveedor;
    const nombreProveedor = proveedor
      ? (proveedor.nombre
        ? `${proveedor.nombre} ${proveedor.apellidoPaterno || ''} ${proveedor.apellidoMaterno || ''}`.trim()
        : proveedor.razonSocial)
      : '';

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Pagar Factura"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        extra={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '6px 14px',
                borderRadius: 6,
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              <CalendarOutlined style={{ color: "#FF6A0D" }} />
              
              <span
                style={{
                  textTransform: 'uppercase',
                  fontSize: 11,
                  letterSpacing: 0.4,
                  color: "#FF6A0D"
                }}
              >
                Vencimiento:
              </span>

              <strong>
                {moment(this.state.datosFactura?.fechaPago).format("LL")}
              </strong>
            </div>
          }
        />

        <div
          style={{
            background: "linear-gradient(135deg, #f0fcfe 0%, #ffffff 100%)",
            padding: "16px 20px",
            marginBottom: 12,
            border: "1px solid #b5edf3",
            borderLeft: "5px solid #00BFD6",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            gap: 12,
            boxShadow: "0 2px 8px rgba(0, 191, 214, 0.08)",
          }}
        >
          <FileTextOutlined style={{ color: "#00BFD6", fontSize: 18 }} />
          <span style={{ color: "#262626", fontWeight: "bold", fontSize: 16 }}>
            {this.state?.datosFactura?.codigoFactura || ""}
          </span>
          <span style={{ color: "#d9d9d9", fontSize: 16 }}>|</span>
          <span style={{ color: "#262626", fontWeight: "bold", fontSize: 16 }}>
            {nombreProveedor || "Cargando..."}
          </span>
        </div>

        {this.state.notasDeCreditoPendiente.length > 0 &&
          <Alert
            onClick={() => this.formRef.current.setFieldsValue({ pagarConNotas: true, notaId: undefined, pagoConCuentaContable: false })}
            style={{ marginBottom: 10, cursor: 'pointer' }}
            description='Cambie a notas de credito para pagar con una de ellas'
            showIcon
            message="Este proveedor contiene notas de credito pendientes"
            type="warning"
          />
        }
        {this.state.abonosPendientesProveedores.length > 0 &&
          <Alert
            onClick={() => this.formRef.current.setFieldsValue({ pagarConAbono: true, abonoId: undefined, pagoConCuentaContable: false })}
            style={{ marginBottom: 10, cursor: 'pointer' }}
            description='Cambie a abonos para cobrar con uno de ellos'
            showIcon
            message="Este proveedor contiene abonos pendientes"
            type="warning"
          />
        }

        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="pagarFactura"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >

               {this.state.datosFactura?.proveedor && (
                <div style={{ padding: "0 16px", marginBottom: 16 }}>
                  {this.renderProveedorInfoCard()}
                </div>
              )}


              <Row gutter={[16, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                  <GeneralFormLayout
                    isMobile={isMobile}
                    cards={[{
                      title: (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                          Moneda
                        </span>
                      ),
                      headerRight: (
                        <div
                          style={{
                            textAlign: 'center',
                            padding: '2px 8px',
                            border: '1px solid #d0eaef',
                            borderRadius: 6,
                            fontSize: 10,
                            minWidth: 60,
                            minHeight: 28,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 1 }}>
                            Moneda Factura: <span>{this.state.datosFactura?.moneda?.abreviacion || '-'}</span>
                          </div>
                         
                        </div>
                      ),
                      content: this.renderMonedaCard(),
                    }]}
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                  <GeneralFormLayout
                    isMobile={isMobile}
                    cards={[{
                      title: (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                          Datos de Pago
                        </span>
                      ),
                      content: this.renderDatosPagoCard(),
                    }]}
                  />
                  <div style={{ padding: '0 16px' }}>
                    {this.renderResumenCard()}
                  </div>
                </Col>
              </Row>
              
              <GeneralFormLayout
                isMobile={isMobile}
                actionButtons={
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    cyanB
                    style={{ width: "5%" }}
                  >
                    Pagar
                  </ButtonItem>
                }
              />
            </Form>
          </Spin>
        </div>
        {this.renderModalAbonos()}
        {this.renderModalComision()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(PagarFactura);
